import { render, staticRenderFns } from "./DetailedModelAdd.vue?vue&type=template&id=6da09580&scoped=true&"
import script from "./DetailedModelAdd.vue?vue&type=script&lang=js&"
export * from "./DetailedModelAdd.vue?vue&type=script&lang=js&"
import style0 from "./DetailedModelAdd.vue?vue&type=style&index=0&id=6da09580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da09580",
  null
  
)

export default component.exports